module.exports = __webpack_public_path__ + "73a6f3746bbbc6e8d908ed64dd0d41d3.svg";